(function () {
  'use strict';

  /*
   * Corrections to how Skio prices its purchase options.
   *
   * 1. Skio renders a struck-through compare price on the one-time option even
   *    when it equals the price, giving "$29.00 $29.00". Hide it unless the
   *    compare is genuinely higher.
   *
   * 2. Skio renders no compare price on the subscription option, so the saving
   *    isn't visible. Show the one-time price struck through beside it.
   *
   * The catch for (2): Skio does not recalculate the subscription price when
   * the shopper changes variant -- pick the 4-pack and the one-time price
   * updates while the subscription price stays on the first variant. Pairing a
   * stale price with the new one-time price would advertise a discount that
   * doesn't exist, so the saving is only shown when the subscription price
   * matches what the row's own stated discount implies. When Skio is out of
   * sync we show nothing rather than a wrong number.
   *
   * Skio re-renders on variant and purchase-type changes, so this re-runs on
   * mutation. Writes are skipped when the value is already correct, so the
   * observer settles instead of looping.
   */

  var ROW = '.skio-group-container';
  var COMPARE_CLASS = 'skio-compare-price';
  var TOLERANCE = 0.02; // 2% -- absorbs currency rounding, not a stale price

  function toNumber(text) {
    var s = String(text || '').replace(/[^\d.,]/g, '');
    if (!s) return NaN;
    var lastDot = s.lastIndexOf('.');
    var lastComma = s.lastIndexOf(',');
    if (lastComma > lastDot) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else {
      s = s.replace(/,/g, '');
    }
    return parseFloat(s);
  }

  function priceWrap(row) {
    return row.querySelector('.skio-price');
  }

  function priceSpan(row) {
    var wrap = priceWrap(row);
    if (!wrap) return null;
    var spans = wrap.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      if (!spans[i].classList.contains(COMPARE_CLASS)) return spans[i];
    }
    return null;
  }

  function isOneTime(row) {
    var input = row.querySelector('input.skio-group-input');
    return !!input && /one-?time/i.test(input.id || '');
  }

  // The stated discount for this row, e.g. "Save 10%" -> 10.
  function statedDiscount(row) {
    var m = String(row.textContent || '').match(/(\d+(?:\.\d+)?)\s*%/);
    return m ? parseFloat(m[1]) : NaN;
  }

  function setDisplay(el, value) {
    if (el.style.display !== value) el.style.display = value;
  }

  function apply() {
    var rows = [].slice.call(document.querySelectorAll(ROW));
    if (!rows.length) return;

    var baseText = null;
    var baseValue = NaN;
    for (var i = 0; i < rows.length; i++) {
      if (!isOneTime(rows[i])) continue;
      var span = priceSpan(rows[i]);
      if (!span) continue;
      baseText = span.textContent.trim();
      baseValue = toNumber(baseText);
    }

    for (var j = 0; j < rows.length; j++) {
      var row = rows[j];
      var wrap = priceWrap(row);
      var own = priceSpan(row);
      if (!wrap || !own) continue;

      var compare = wrap.querySelector('.' + COMPARE_CLASS);
      var price = toNumber(own.textContent);

      if (isOneTime(row)) {
        // Only ever hide here -- never invent a saving on the base price.
        if (!compare) continue;
        setDisplay(compare, toNumber(compare.textContent) > price ? '' : 'none');
        continue;
      }

      var discount = statedDiscount(row);
      var trustworthy = false;
      if (!isNaN(baseValue) && !isNaN(price) && !isNaN(discount) && baseValue > price) {
        var expected = baseValue * (1 - discount / 100);
        trustworthy = expected > 0 && Math.abs(price - expected) / expected <= TOLERANCE;
      }

      if (!trustworthy) {
        if (compare) setDisplay(compare, 'none');
        continue;
      }

      if (!compare) {
        compare = document.createElement('span');
        compare.className = COMPARE_CLASS;
        wrap.appendChild(compare);
      }
      if (compare.textContent.trim() !== baseText) compare.textContent = baseText;
      setDisplay(compare, '');
    }
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      apply();
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
